import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import { fetchDropsDynamics } from "../../api/dripPlan";
import type { DynamicItem } from "../../api/dripPlan";

const DropsDynamicsPage = () => {
  const [list, setList] = useState<DynamicItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchDropsDynamics()
      .then((data) => setList(Array.isArray(data) ? data : []))
      .catch(() => setList([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#F9F9F9]">
      <Navbar />

      <section className="pt-24 md:pt-28 pb-12 md:py-20 bg-white">
        <div className="max-w-[1400px] mx-auto px-6">
          <div className="text-center mb-8 md:mb-12">
            <h1 className="text-3xl md:text-5xl font-bold text-[#2A7A62] mb-2 md:mb-4">
              点滴动态
            </h1>
            <p className="text-lg md:text-2xl text-[#6C6C6C] font-light mb-2">
              记录点滴，传递温暖
            </p>
            <p className="text-sm md:text-base text-[#6C6C6C] max-w-2xl mx-auto">
              了解项目最新进展与公益活动动态
            </p>
          </div>

          {loading ? (
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-6">
              {[1, 2, 3, 4, 5, 6].map((i) => (
                <div
                  key={i}
                  className="bg-[#F9F9F9] rounded-xl md:rounded-2xl overflow-hidden shadow-lg min-h-[200px] flex items-center justify-center border border-[#E0E0E0] animate-pulse"
                >
                  <span className="text-[#6C6C6C] text-sm">加载中...</span>
                </div>
              ))}
            </div>
          ) : list.length === 0 ? (
            <div className="text-center py-16 text-[#6C6C6C]">
              <p className="mb-2">暂无点滴动态</p>
              <p className="text-sm">请在管理端「动态发布」中添加内容，并将展示位置选为「点滴动态」</p>
            </div>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-6">
              {list.map((item) => (
                <Link
                  key={item.id}
                  to={`/story/${item.id}`}
                  className="bg-white rounded-xl md:rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer group border border-[#E0E0E0]"
                >
                  <div className="relative h-32 md:h-[200px] overflow-hidden bg-[#F9F9F9]">
                    {item.image ? (
                      <img
                        src={item.image}
                        alt={item.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center text-[#6C6C6C]">
                        <i className="ri-file-text-line text-4xl"></i>
                      </div>
                    )}
                    {item.category ? (
                      <div className="absolute top-2 right-2 md:top-3 md:right-3 px-2 py-1 md:px-3 md:py-1.5 bg-[#2A7A62] text-white text-xs font-medium rounded-full">
                        {item.category}
                      </div>
                    ) : null}
                  </div>
                  <div className="p-3 md:p-4 space-y-2">
                    <h3 className="text-sm md:text-lg font-bold text-[#1E1E1E] line-clamp-2">
                      {item.title}
                    </h3>
                    <p className="text-xs md:text-sm text-[#6C6C6C] leading-relaxed line-clamp-2 hidden md:block">
                      {item.excerpt}
                    </p>
                    <div className="flex items-center justify-between pt-2 border-t border-[#E0E0E0] text-xs text-[#6C6C6C]">
                      <span className="flex items-center gap-1">
                        <i className="ri-calendar-line"></i>
                        {item.date || "—"}
                      </span>
                      <span className="text-[#2A7A62] font-medium flex items-center gap-1">
                        阅读
                        <i className="ri-arrow-right-line"></i>
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default DropsDynamicsPage;
